import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { FAQSection } from "@/components/sections/FAQSection";
import { CTASection } from "@/components/sections/CTASection";
import { SEO } from "@/components/SEO";
import { useLanguage } from "@/contexts/LanguageContext";

const FAQ = () => {
  const { t } = useLanguage();
  const faqs = Array.from({ length: 9 }, (_, i) => ({
    "@type": "Question",
    name: t(`faq.q${i + 1}` as Parameters<typeof t>[0]),
    acceptedAnswer: {
      "@type": "Answer",
      text: t(`faq.a${i + 1}` as Parameters<typeof t>[0]),
    },
  }));
  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs,
  };
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="FAQ | It's All About Growth"
        description="Honest answers about pricing, scope, fractional vs full-time CMO, and what to expect from working with IAAG."
        path="/faq"
        jsonLd={faqJsonLd}
      />
      <Header />
      <main className="pt-20">
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default FAQ;
